import { render, staticRenderFns } from "./Form10Resolution.vue?vue&type=template&id=74957dac&scoped=true&"
import script from "./Form10Resolution.vue?vue&type=script&lang=js&"
export * from "./Form10Resolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74957dac",
  null
  
)

export default component.exports